module.exports = __webpack_public_path__ + "img/INSIGHTS (2).18b7feb1.png";